// ESM-Konvertierung von lib/scripts/FNC_tools.js (Phase 4, Welle 2b) -
// die ~35 freien Hilfsfunktionen des Projekts. Huellen-Muster; der
// $(function(){...})-Block registriert das jQuery-UI-Combobox-Widget
// (Registrierung bei Modul-Init, feuert wie bisher erst bei ready).
// Strict-Mode-Fix (ESM): diese Namen wurden im Classic-Sloppy-Mode als
// implizite window-Globals angelegt (Zuweisung ohne var) - in Modulen
// wirft das ReferenceError. Modul-weite Deklaration stellt das alte
// Verhalten (dateiuebergreifend ungenutzte Temp-Variablen) her.
var cents, day, f64, i, ip, ipaddress, month, re, split_result, year;


function combine(sink, source) {
    var sink;

    if (!sink) {
        sink = new Object();
    } else {
        // sink = eval (sink.toSource ());
        //sink = eval (toSource(sink));
        //sink = JSON.parse (toSource(sink));
        sink = jQuery.extend({}, sink);
    }
    if (!sink)
        sink = new Object();

    for (var i in sink)
        if (typeof sink[i] == "object") {
            if (source && typeof source[i] == "object")
                sink[i] = combine(sink[i], source[i]);
        } else {
            if (source && typeof source[i] != "undefined" && typeof source[i] != "object")
                sink[i] = source[i];
        }

    for (var n in source)
        if (typeof sink[n] == "undefined")
            if (source && typeof source[n] == "object")
                sink[n] = combine(null, source[n]);
            else
                sink[n] = source[n];

    return sink;
}
/*
function toSource(emp){
var ret = (emp.toSource) ? emp.toSource() : emp.toString();
return ret;
}
 */
function toSource(data) {
    var str = JSON.stringify(data);
    return str;
    /*var str = "{";
    if (data instanceof Object) {
    //var arr = [];
    for (var datapart in data) {
    //arr.push(toSource(datapart));
    str = str + datapart + ":\"" + data[datapart] + "\",";
    }
    //return "[" + arr.join(",") + "]";
    }
    // Warning: we expect all array elements to be digits, do not use this if the
    // data can be a random string
    str = str.substring(0, str.length - 1);
    str = str +"}";
    return str;*/
}

function getRandomNumber(min, max) {
    var rand = Math.round(Math.random() * (max - min) + min);
    return rand;
}

function float2formatString(number) {
    var Result = new String(number);
    var NoComma = false;

    var Negative = Result.indexOf("-") != -1;

    if (Negative)
        Result = Result.substr(1, Result.length - 1);

    // replace Comma
    Result = Result.replace("\.", ",");

    // count digits before comma
    var digits = Result.indexOf(",");
    if (digits == -1) {
        digits = Result.length;
        NoComma = true;
    }

    var commaLen = Result.length - digits;

    var tripleborder = digits / 3;

    for (var triples = 1; triples < tripleborder; triples++) {
        Result = Result.substr(0, digits - 4 * triples + 1) + "." + Result.substr(digits - 4 * triples + 1, commaLen + 4 * triples + 1);
        digits++;
    }

    if (Negative)
        Result = "-" + Result;

    if (commaLen < 1 && !NoComma)
        Result = Result + ",";

    for (var cnt = 3; !NoComma && cnt > commaLen; cnt--)
        Result = Result + "0";

    return Result;
}

function fix2Decimals(param) {
    return Math.round(Number(param) * 100) / 100;
}

function convert2Hex(num) {
    return num.toString(16).toUpperCase();
}

function float2StringD2(param) {
    var f = Number(param).toFixed(2);
    var p = Number(param).toFixed(1);
    var r = Number(param).toFixed(0);

    if (r == f)
        return float2formatString(r + ".00");
    if (p == f)
        return float2formatString(r + "0");

    return float2formatString(f);
}

function remEuropeanComma(number) {
    var ret = String(number).replace(",", ".");
    return ret;
}

function remAmericanComma(number) {
    var ret = String(number).replace(".", ",");
    return ret;
}

function sdump(a, b, c, d, e, f) {
    var dm = "\n" + a;

    if (b == undefined) {
        dump(dm);
        return;
    }

    dm += " | " + b;

    if (c == undefined) {
        dump(dm);
        return;
    }

    dm += " | " + c;

    if (d == undefined) {
        dump(dm);
        return;
    }

    dm += " | " + d;

    if (e == undefined) {
        dump(dm);
        return;
    }

    dm += " | " + e;

    if (f == undefined) {
        dump(dm);
        return;
    }

    dm += " | " + f;

    dump(dm);
}

function dump(msg) {
    console.log(msg);
}

function fdumpsub(a, b, c, d, e, f) {
    var dm = "\n" + a;

    if (b == undefined) {
        return dm;
    }

    dm += " | " + b;

    if (c == undefined) {
        return dm;
    }

    dm += " | " + c;

    if (d == undefined) {
        return dm;
    }

    dm += " | " + d;

    if (e == undefined) {
        return dm;
    }

    dm += " | " + e;

    if (f == undefined) {
        return dm;
    }

    dm += " | " + f;

    return dm;
}

function fdump(filename, a, b, c, d, e, f) {
    /*privMan.enablePrivilege (privList);*/

    /*var conv = Components.classes["@mozilla.org/network/protocol;1?name=file"].
    createInstance (Components.interfaces.nsIFileProtocolHandler);*/
    /*
    var fp = conv.getFileFromURLSpec ("file://" + filename);

    if (!fp.exists)
    fp.create (Components.interfaces.nsIFile.NORMAL_FILE_TYPE, 0640);

    var outputStream = Components.classes["@mozilla.org/network/file-output-stream;1"].
    createInstance (Components.interfaces.nsIFileOutputStream);
    outputStream.init (fp, 0x02 | 0x08 | 0x10, 640, 0);
     */
    var text = fdumpsub(a, b, c, d, e, f);
    /*
    outputStream.write (text, text.length);

    outputStream.close ();
     */

    var fh = new CFileHandler(this.path);
    fh.append(text);
}

function expandInteger(number, digits) {
    var len = String(number).length;
    var res = String(number);

    for (; len < digits; len++) {
        res = "0" + res;
    }

    return res;
}

function umlauToEntity(text) {
    text = String(text);
    text = text.replace(/�/g, "&szlig;");
    text = text.replace(/�/g, "&uuml;");
    text = text.replace(/�/g, "&Uuml;");
    text = text.replace(/�/g, "&auml;");
    text = text.replace(/�/g, "&Auml;");
    text = text.replace(/�/g, "&ouml;");
    text = text.replace(/�/g, "&Ouml;");
    return text;
}

function entityToUmlau(text) {
    text = String(text);
    text = text.replace(/&szlig;/g, "�");
    text = text.replace(/&uuml;/g, "�");
    text = text.replace(/&Uuml;/g, "�");
    text = text.replace(/&auml;/g, "�");
    text = text.replace(/&Auml;/g, "�");
    text = text.replace(/&ouml;/g, "�");
    text = text.replace(/&Ouml;/g, "�");
    return text;
}

function htmlEncode(value) {
    //create a in-memory div, set it's inner text(which jQuery automatically encodes)
    //then grab the encoded contents back out.  The div never exists on the page.
    return $('<div/>').text(value).html();
}

function htmlDecode(value) {
    return $('<div/>').html(value).text();
}

function toLowerCaseButFirst(string) {
    var newString = "";

    if (!string)
        return;

    var stringParts = string.split(" ");

    for (var i = 0; i < stringParts.length; i++) {
        for (var j = 0; j < stringParts[i].length; j++) {
            if (j == 0)
                newString += stringParts[i][0].toUpperCase();
            else
                newString += stringParts[i][j].toLowerCase();
        }

        newString += " ";
    }

    return newString;
}

function getNow() {
    var now = new Date();
    now = Number(now).toFixed(0);
    return now;
}

function measure(past, text) {
    var now = getNow();
    var time = now - past;
    sdump(text, time);
}

function decToHexa(num) {
    var hexadecimal = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8",
        "9", "A", "B", "C", "D", "E", "F");

    var hexaDec = Math.floor(num / 16);
    var hexaUni = num - (hexaDec * 16);

    return (hexadecimal[hexaDec] + hexadecimal[hexaUni]).toString();
}

// ---------------------------------------------------------------------------
// Takes a string, already representing a date, and formats it using 'format'.
// 'dateString' must conform to the universal date format, such as YYMMDD.
// Returns the properly formatted date representation.
// Currently supported format specifiers:
// yy or yyyy - year
// mm         - month (number)
// dd         - day
// Caution: dateString NEVER NEVER NEVER is an actual date (e.g. seconds since
// 1970).
// Example:
// var newDateString = formatDateString("061122", "mm-dd-20yy");
// will generate output
// 11-22-2006
// ---------------------------------------------------------------------------
function formatDateString(dateString, format) {
    var yearStr = "";
    var monthStr = "";
    var dayStr = "";

    var len = dateString.length;
    if (len == 6) {
        yearStr = dateString.substr(0, 2);
        monthStr = dateString.substr(2, 2);
        dayStr = dateString.substr(4, 2);
    } else if (len == 8) {
        yearStr = dateString.substr(0, 4);
        monthStr = dateString.substr(4, 2);
        dayStr = dateString.substr(6, 2);
    } else
        return "-";

    re = /(yyyy|yy)/;
    format = format.replace(re, yearStr);
    re = /mm/;
    format = format.replace(re, monthStr);
    re = /dd/;
    format = format.replace(re, dayStr);

    return format;
}

// ---------------------------------------------------------------------------
// Takes a string, that already represents a time, and puts it into
// the format, given by 'format'. Hopefully returns the properly formatted
// time representation.
// Currently supported format specifiers:
// hh - hours
// MM - minutes
// Caution: timeString NEVER NEVER NEVER is an actual time (e.g. seconds since
// 1970).
// ---------------------------------------------------------------------------
function formatTimeString(timeString, format) {
    var hourStr = timeString.substr(0, 2);
    var minStr = timeString.substr(2, 2);
    var secStr = ""; //timeString.substr(4, 2);

    re = /hh/;
    format = format.replace(re, hourStr);
    re = /MM/;
    format = format.replace(re, minStr);
    re = /ss/;
    format = format.replace(re, secStr);

    return format;
}

function currentDateString(format) {
    var now = new Date();

    if (format == null || format == "")
        return now.getFullYear() +
            expandInteger(now.getMonth(), 2) +
            expandInteger(now.getDate(), 2);

    re = /(yyyy|yy)/;
    format = format.replace(re, now.getFullYear());
    re = /mm/;
    format = format.replace(re, expandInteger(now.getMonth() + 1, 2));
    re = /dd/;
    format = format.replace(re, expandInteger(now.getDate(), 2));

    return format;
}

function currentTimeString(format) {
    var now = new Date();

    if (format == null || format == "")
        return expandInteger(now.getHours(), 2) +
            expandInteger(now.getMinutes(), 2) +
            expandInteger(now.getSeconds(), 2);

    re = /hh/;
    format = format.replace(re, expandInteger(now.getHours(), 2));
    re = /MM/;
    format = format.replace(re, expandInteger(now.getMinutes(), 2));
    re = /ss/;
    format = format.replace(re, expandInteger(now.getSeconds(), 2));

    return format;
}


function cent2Euro(centStr) {
    cents = parseFloat(centStr);
    return cents / 100;
    //return float2formatString(cents);
    //return float2StringD2(cents/100);
}


function DateToString(date) {
    year = date.getFullYear();
    month = ("0" + (date.getMonth() + 1)).substr(-2);
    day = ("0" + date.getDate()).substr(-2);
    return year + "-" + month + "-" + day;
}


function b64t2d(t) // http://aktuell.de.selfhtml.org/artikel/javascript/utf8b64/base64.htm
{
    var d = [];
    var i = 0;
    // zur decodierung die Umbrueche killen
    t = t.replace(/\n|\r/g, "");
    t = t.replace(/=/g, "");
    while (i < t.length) {
        d[d.length] = (f64[t.charAt(i)] << 2) | (f64[t.charAt(i + 1)] >> 4);
        d[d.length] = (((f64[t.charAt(i + 1)] & 15) << 4) | (f64[t.charAt(i + 2)] >> 2));
        d[d.length] = (((f64[t.charAt(i + 2)] & 3) << 6) | (f64[t.charAt(i + 3)]));
        i += 4;
    }
    if (t.length % 4 == 2)
        d = d.slice(0, d.length - 2);
    if (t.length % 4 == 3)
        d = d.slice(0, d.length - 1);
    return d;
}

function lrtrim(str) {
    if (!str)
        return "";

    var res = "";
    var c = 0;
    for (i = 0; i < str.length; i++) {
        if (str.charAt(i) != " " || c > 0) {
            res += str.charAt(i);
            if (str.charAt(i) != " ")
                c = res.length;
        }
    }
    return res.substr(0, c);
}

function execute(str, timeout) {


    if (!timeout) {
        timeout = 30000;
    }
    var defret = jQuery.Deferred();
/*  
  var execto = setTimeout(function() {
        var execstr = str;
        if (defret.state() == "pending") {
            log.add(1, "Info", "execute resolved after timeout ", execstr);
            defret.resolve(null); //resolved after 15 s
        }
    }, timeout);
	
	
	$.ajax({
        type: "GET",
        url: "execute.php",
//        async: false,
 data: {
        "cmd": str
    },
        cache: false,
		 success: function(response) {
			defret.resolve(response);
    },
    error: function(xhr) {
			defret.resolve("Command not successful!");
    }
    });
	*/
defret.resolve(null);
  return defret.promise();
}

function executeCommand(str){
	execute(str);
}


/*
function execute(str, txt) {

var defret = $.Deferred();
var util = require('util'),
exec = require('child_process').exec,
child;

child = exec(str, // command line argument directly in string
function (error, stdout, stderr) { // one easy function to capture data/errors
console.log('stdout: ' + stdout);
console.log('stderr: ' + stderr);
if (error) {
console.log('exec error: ' + error);
log.add(1, "Error", txt, error);
defret.resolve(false);
return;
} else {
defret.resolve(true);
return;
}
defret.resolve(true);
});
return defret.promise();
}
 */
// Reaktiviert beim ESM-Umzug (Welle 2b): einziger Aufrufer ist der
// UpdateServer-Fallback in CLS_CPOS.runPOSPush - die Funktion existierte
// nur auskommentiert, der Fallback-Zweig waere mit ReferenceError
// gecrasht (latent; ini.xml hat den Eintrag normalerweise).
function getValueFromINIXML(parameter) {

	var ver2 = fs.readFileSync("var/etc/ini.xml", "utf-8");
	var value = null;
	$(ver2).find(parameter).each(function () {
		value = $(this).text();
	});
	return value;
}

function getMyIP(POS) {
    var defret = jQuery.Deferred();
    try {
        if ((POS != null) && (POS.MyIP != null)) {
            defret.resolve(POS.MyIP);
        } else {
            $.when(execute("sudo /usr/bin/ssh -i /home/pos/.ssh/id_dsa -o StrictHostKeyChecking=no pos@" + POS.UpdateServer + " '/bin/echo $SSH_CLIENT;/bin/echo " + POS.POSId + "/$SSH_CLIENT/" + currentDateString('yyyy-mm-dd') + "/" + currentTimeString('hh:MM:ss') + ">>/huge/posdata/boot/boots.txt;';exit;", 200)).done(function(result) {

                if (result) {
                    if (result.indexOf(":") == 0) {
                        split_result = result.split(":");
                        result = split_result[3];
                    }
                    ipaddress = result.split(" ");
                    ip = ipaddress[0];
                } else {
                    ip = null;
                }
                var login = "";
                /*  var userid = POS.sessions.openSessions[POS.sessions.currentSession].userProps["Login"]; //'1070';
                  if (userid) {
                      login = userid;
                  }*/
                $.when(execute("today=`date '+%Y_%m_%d__%H_%M_%S'`;tail -c 5000 /home/pos/var/log/POSysseus.log>/tmp/error.txt;rsync -e 'ssh -i /home/pos/.ssh/id_dsa -o StrictHostKeyChecking=no' /tmp/error.txt   pos@" + POS.UpdateServer + ":/huge/posdata/boot/boot_" + POS.POSId + "_" + login + "_$today;", 200)).done(function(result) {

                });
                defret.resolve(ip);
            });
        }
    } catch (e) {
        log.add(1, "Error", "getMyIP failed: " + e.message, "");
        defret.resolve(null);
    }
    return defret.promise();
}



$(function() {
    $.widget("custom.combobox", {
        _create: function() {
            this.wrapper = $("<span>")
                .addClass("custom-combobox")
                .insertAfter(this.element);

            this.element.hide();
            this._createAutocomplete();
            this._createShowAllButton();
        },

        _createAutocomplete: function() {
            var selected = this.element.children(":selected"),
                //value = selected.val() ? selected.text() : "";
                value = ""; //initialer Wert in der inputbos
            var me = this;
            $(this.element).addClass("combobox");
            this.input = $("<input>")
                .appendTo(this.wrapper)
                //					.val(value)
                .attr("title", "")
                .attr("id", me.element[0].id + "_input")
                //			.addClass("custom-combobox-input ui-widget ui-widget-content ui-state-default ui-corner-left")
                .addClass("custom-combobox-input")
                .autocomplete({
                    delay: 0,
                    minLength: 0,
                    source: $.proxy(this, "_source")
                })
                .tooltip({
                    classes: {
                        "ui-tooltip": "ui-state-highlight"
                    }
                })
                .keydown(function(e) {
                    if (e.which == 13) {
                        //alert('enter key is pressed');
                        e.preventDefault();
                        //  $(this).next().focus();
                        //  $.tabNext();
                        //$('input,select,textarea')[$('input,select,textarea').index(this) + 1].focus();
                        var name = this.id.split("_");
                        $('.combobox').trigger("combo:change:" + name[0], [$(this).val(), name]);
                    }
                });

            this._on(this.input, {
                autocompleteselect: function(event, ui) {
                    ui.item.option.selected = true;
                    var name = event.currentTarget.id.split("_")[0];
                    //ui.item.value = ui.item.text;
                    this.input.attr('data', ui.item.data);
                    this._trigger("select", event, {
                        item: ui.item.option
                    });
                    $('.combobox').trigger("combo:change:" + name, [ui.item.value, name, ui.item.text, ui.item.data]);
                },

                autocompletechange: "_removeIfInvalid"
            });

            $('.custom-combobox-input').trigger("inputchange");
        },

        _createShowAllButton: function() {
            var input = this.input,
                wasOpen = false;

            $("<a>")
                .attr("tabIndex", -1)
                .attr("title", "Alle Optionen")
                .tooltip()
                .appendTo(this.wrapper)
                .button({
                    icons: {
                        primary: "ui-icon-triangle-1-s"
                    },
                    text: false
                })
                .removeClass("ui-corner-all")
                .addClass("custom-combobox-toggle ui-corner-right")
                .on("mousedown", function() {
                    wasOpen = input.autocomplete("widget").is(":visible");
                })
                .on("click", function() {
                    input.trigger("focus");

                    // Close if already visible
                    if (wasOpen) {
                        return;
                    }

                    // Pass empty string as value to search for, displaying all results
                    input.autocomplete("search", "");
                });
        },

        _source: function(request, response) {
            var matcher = new RegExp($.ui.autocomplete.escapeRegex(request.term), "i");
            response(this.element.children("option").map(function() {
                var text = $(this).text();
                var val = $(this).val();
                //var text = $(this).val();
                if (this.value && (!request.term || matcher.test(text)))
                    return {
                        text: text,
                        label: text,
                        value: text,
                        data: val,
                        option: this
                    };
            }));
        },

        _removeIfInvalid: function(event, ui) {
            if (ui && ui.item && ui.item.text)
                $(this).text(ui.item.text);
            return;
            // Selected an item, nothing to do
            if (ui.item) {
                return;
            }

            // Search for a match (case-insensitive)
            var value = this.input.val(),
                valueLowerCase = value.toLowerCase(),
                valid = false;
            this.element.children("option").each(function() {
                if ($(this).text().toLowerCase() === valueLowerCase) {
                    this.selected = valid = true;
                    return false;
                }
            });

            // Found a match, nothing to do

            if (valid) {
                return;
            }

            // Remove invalid value
            this.input
                .val("")
                .attr("title", value + " didn't match any item")
                .tooltip("open");
            this.element.val("");
            this._delay(function() {
                this.input.tooltip("close").attr("title", "");
            }, 2500);
            this.input.autocomplete("instance").term = "";
        },

        _destroy: function() {
            this.wrapper.remove();
            this.element.show();
        }
    });

});



function checkBusyDates(date) {
    const weekdays = [1, 2, 3, 4]; // Montag (1) bis Donnerstag (4)
    const specialDates = [
        { month: 1, day: 13 }, // 13. Februar
        { month: 1, day: 14 }, // 14. Februar
        { month: 2, day: 7 },  // 7. März
        { month: 2, day: 8 }   // 8. März
    ];

    const dayOfWeek = date.getDay(); // Sonntag = 0, Montag = 1, ..., Samstag = 6
    const month = date.getMonth(); // Januar = 0, Februar = 1, ...
    const day = date.getDate();
    
    // Prüfen, ob Montag bis Donnerstag
    const isWeekday = weekdays.includes(dayOfWeek);
    
    // Prüfen, ob es ein spezieller Tag ist
    const isSpecialDate = specialDates.some(d => d.month === month && d.day === day);
    
    // Muttertag: Zweiter Sonntag im Mai
    const motherDay = new Date(date.getFullYear(), 4, 1); // 1. Mai
    while (motherDay.getDay() !== 0) {
        motherDay.setDate(motherDay.getDate() + 1); // Erster Sonntag
    }
    motherDay.setDate(motherDay.getDate() + 7); // Zweiter Sonntag
    
    const isMotherDay = date.getDate() === motherDay.getDate() && month === 4;
    const isDayBeforeMotherDay = date.getDate() === motherDay.getDate() - 1 && month === 4;
    
    return !isWeekday || isSpecialDate || isMotherDay ||isDayBeforeMotherDay;
}

export { combine, toSource, getRandomNumber, float2formatString, fix2Decimals, convert2Hex, float2StringD2, remEuropeanComma, remAmericanComma, sdump, dump, fdumpsub, fdump, expandInteger, umlauToEntity, entityToUmlau, htmlEncode, htmlDecode, toLowerCaseButFirst, getNow, measure, decToHexa, formatDateString, formatTimeString, currentDateString, currentTimeString, cent2Euro, DateToString, b64t2d, lrtrim, execute, executeCommand, getMyIP, getValueFromINIXML, checkBusyDates };
